import { EntityField } from "@skinsoft/types";
import { OfflineDataFetcher } from "../offline-data-fetcher"

import { dbCacheDown } from "../dexie/cache-down";
import { STATS_KEYS } from "../dexie/stats-keys";

export class EntityFieldOfflineDataFetcher extends OfflineDataFetcher<EntityField> {
    constructor() {
        super(dbCacheDown.entityField, STATS_KEYS.entityField)
    }
}